import {Injectable} from '@angular/core';
import {DataOBJ, DataObjService, RestService} from './rest-service';
import {Observable} from 'rxjs/Observable';
import {HttpClient} from '@angular/common/http';

@Injectable()
export class AccountCodeService implements DataObjService<AccountCode> {

  restHelper: RestService<AccountCode>;

  readonly apiPath = '/api/call_event/v1/account_code';

  constructor(private httpClient: HttpClient) {
    this.restHelper = new RestService<AccountCode>(this.apiPath, httpClient, AccountCode.fromJSON)
  }

  findByAccountCodeAndCustomerId(accountCode: AccountCode, customerId: string): Observable<AccountCode> {
    return this.httpClient.get<AccountCode>(this.apiPath + `/customer/${customerId}/account_code/${accountCode}`)
  }

  findByUserIdAndCustomerId(userId: string, customerId: string): Observable<Array<AccountCode>> {
    return this.httpClient.get<Array<AccountCode>>(this.apiPath + `/customer/${customerId}/user/${userId}`)
  }

  getAll(): Observable<AccountCode[]> {
    return this.restHelper.getAll();
  }

  getAllByCustomerId(customerId: string): Observable<AccountCode[]> {
    return this.restHelper.getAllByCustomerId(customerId);
  }

  getById(id: string): Observable<AccountCode> {
    return this.restHelper.getById(id);
  }

  save(obj: AccountCode): Observable<AccountCode> {
    return this.restHelper.save(obj);
  }

  update(obj: AccountCode): Observable<AccountCode> {
    return this.restHelper.update(obj);
  }

  delete(obj: AccountCode): Observable<string> {
    return this.restHelper.delete(obj);
  }

}

export class AccountCode implements DataOBJ {

  static fromJSON(json: any): AccountCode {
    const object: AccountCode = Object.create(AccountCode.prototype);
    Object.assign(object, json);
    return object;
  }

  constructor(public id: string, public customerId: string, public userId: string, public accountCode: string,
              public deleted: boolean) {
  }

  getHumanIdentifier() {
    return this.accountCode;
  }

}



// WEBPACK FOOTER //
// /Users/tabelini/development/jvm/tenacity/pysix/PysixCloud/src/app/account-code.service.ts